import { render } from "./AutocompleteInput.vue?vue&type=template&id=23bd5be6&scoped=true"
import script from "./AutocompleteInput.vue?vue&type=script&lang=js"
export * from "./AutocompleteInput.vue?vue&type=script&lang=js"

import "./AutocompleteInput.vue?vue&type=style&index=0&id=23bd5be6&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bd5be6"]])

export default __exports__